const MainLoaderModal = () => {
  return (
    <div
      style={{
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: "#0000002a",
        top: 0,
        left: 0,
        zIndex: 9999,
        textAlign: "center",
        placeContent: "center",
      }}
    >
      <span className="loader" />
    </div>
  );
};

export default MainLoaderModal;
